<!--
---
name: RequestMembership
category: Interactions
---

# Request Membership

A simple request membership prompt.
-->

<template>
  <button
    @click.prevent="JoinOrga"
    class="fr-btn fr-btn--secondary fr-btn--secondary-blue-x fr-btn--icon-right fr-mr-3v redesign-button"
  >
    <span class="text-decoration-underline">{{ $t('Ask to join the organization as a producer') }}</span>
    <span class="fr-ml-2w">
      <svg width="14" height="10" viewBox="0 0 14 10" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.3 0.7L12.1 4.5H0V5.5H12.1L8.3 9.3L9 10L14 5L9 0L8.3 0.7Z" fill="#4B90F5"/>
        </svg>
    </span>
  </button>
</template>

<script>

export default {
  props: {
    orga: String,
  },
data() {
    return {
        comment: '',
    };
},
  methods: {
    JoinOrga: function () {

      this.$auth();

      this.comment = prompt(this.$t('You can add some details here for your membership request'));

      this.$api.post("organizations/" + this.orga + "/membership/", {comment: this.comment})
          .then(data => {
            alert(this.$t('A request has been sent to the administrators'));
            window.location.reload();
        })
        .catch(error => {
            alert(this.$t('Error while requesting membership'));
            log.error(error);
        });
      }
  }
};
</script>
